export default "__VITE_ASSET__BrtdsIkw__"